module.exports = __webpack_public_path__ + "img/k1.a8d5cd4f.png";